export default __webpack_public_path__ + "static/media/3.359427db.jpeg";